module.exports = __webpack_public_path__ + "static/hut-audio-85017ff48f45f627c1af8199348661fd.mp3";